import React from 'react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import { defs } from '../Shared/defs'
import UserBasicInfo from './UserBasicInfo'
import UserWorkProfile from './UserWorkProfile'
import UserLogUrls from './UserLogUrls'
import UserIdentityVerfification from './UserIdentityVerification'
import UserCompanyWorkerProfile from './UserCompanyWorkerProfile'
import UserExternalTrainingInfo from './UserExternalTrainingInfo'
import UserWork from './UserWork'
import UserEvents from './UserEvents'
import { User } from '../Shared/common_defs'
import UserJobRequests from './JobRequests/UserJobRequests'
import UserReferralInfo from './UserReferralInfo'
import UserPayment from './UserPayment/UserPayment'
import { UserPrescreenedPositions } from './PrescreenedPositions'

interface Props {
  user: User
  search: (e?: any) => void
  showPaymentSection?: boolean
}

const UserRecord = ({ user, search, showPaymentSection = true }: Props) => {
  return (
    <div className="mt-2 mb-5">
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          maxWidth: '100%',
          marginTop: defs.marginM,
        }}
      >
        <UserBasicInfo user={user} refreshData={search} />
        <UserWorkProfile user={user} refreshData={search} />
        <UserIdentityVerfification user={user} refreshData={search} />
        <UserLogUrls user={user} />
        <UserCompanyWorkerProfile user={user} />
        <UserPrescreenedPositions userId={Number(user.id)} />
        <UserExternalTrainingInfo user={user} />
        <UserEvents user={user} />
        <UserJobRequests user={user} />
        <UserReferralInfo user={user} />
      </div>

      <hr />
      {/* Migrating towards detailed user endpoint where payment is a separate tab */}
      {showPaymentSection ? (
        <>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              marginTop: defs.marginM,
              marginBottom: defs.marginXL,
            }}
          >
            <UserPayment user={user} />
          </div>

          <hr />
        </>
      ) : null}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: defs.marginM,
          marginBottom: defs.marginXL,
        }}
      >
        <UserWork user={user} />
      </div>
    </div>
  )
}

export default UserRecord
